
// export const BASE_URL = 'http://localhost:4000/';
export const BASE_URL = 'https://admin-panel-oe30.onrender.com';

